import classNames from "classnames";
import styles from "./stepper.module.scss";

const Stepper = ({
  noOfSteps,
  titles,
  currentStep,
  onStepClick,
}: {
  noOfSteps: number;
  titles: string[];
  currentStep: number;
  onStepClick?: (step: number) => void;
}) => {
  return (
    <section className={styles.steps}>
      {Array.from({ length: noOfSteps }, (_, index) => {
        const step = index + 1;
        // Only steps already reached can be jumped to directly - this lets
        // an applicant revisit a filled-in tab without letting them skip
        // ahead of steps they haven't completed yet.
        const isReached = step <= currentStep;
        const handleClick = isReached
          ? () => onStepClick?.(step)
          : undefined;

        return (
          <div key={index} className={styles.step}>
            <div className={styles.flex}>
              {index !== 0 ? (
                <span
                  className={classNames(
                    styles.stepLine,
                    index !== 0 && step <= currentStep ? styles.invisible : ""
                  )}
                ></span>
              ) : null}
              <span
                onClick={handleClick}
                role={handleClick ? "button" : undefined}
                tabIndex={handleClick ? 0 : undefined}
                onKeyDown={
                  handleClick
                    ? (e) => {
                        if (e.key === "Enter" || e.key === " ") handleClick();
                      }
                    : undefined
                }
                className={classNames(
                  currentStep >= step ? styles.stepCircle : styles.greyStepCircle,
                  currentStep > step ? styles.done : "",
                  handleClick ? styles.clickable : ""
                )}
              >
                {step}
              </span>
            </div>
            <span
              onClick={handleClick}
              className={classNames(
                currentStep < step ? styles.notReached : "",
                styles.responsiveLg,
                handleClick ? styles.clickable : ""
              )}
            >
              {titles[index]}
            </span>
          </div>
        );
      })}
    </section>
  );
};

export default Stepper;
